import React, {useEffect, useState} from "react";
import axios from "axios";
import banner from "./banner.jpg";
import {Link} from "react-router-dom";
import './index.css';
import reviewService from "../services/ReviewService";
import {RestaurantEdit} from "../ManageRestaurant/RestaurantEdit";

// User profile's display banner with Edit Profile. [Full Access]
const ProfileComponent = () => {

//check if a session is going on
    const[user, setUser] = useState("")

//using axios for easy fetching
    useEffect( () => {
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {
            console.log(response.data)

            // Get the complete data about the user.
            if(response.data) {
                console.log("here!!")
                setUser(response.data)
            }
        });
    }, []);

    // Get list of reviews based on userId.
    const [reviewList, setReview] = useState([]);
    useEffect(() =>
                  reviewService.findAllUserReviews(user.userId).then(review => setReview(review)), [user.userId]);

    return(
        <>
            <div className="container">
                <div className="row pb-5">
                    <div>
                        <div className="wd-image-stack-item-bottom ">
                            <img src = {banner} alt="userBanner" className="img-fluid wd-banner-pic"/>
                        </div>
                        <div className="wd-image-stack-item-top m-0 mb-5">
                            <div className={"row"}>
                                <div className={" col-8 col-sm-8 col-md-9 col-lg-9 col-xl-10"}>
                                    {user.name}
                                    <div style={{fontSize: "large"}}>@{user.userId}</div>
                                </div>
                                <div className={"col"}>
                                    <div className={" d-none d-sm-none d-md-none d-md-none d-lg-block col-xl-block"} style={{fontSize: "xx-large"}}>
                                        <div>Reviews | {reviewList.length}</div>
                                    </div>
                                    <div className={" d-block d-sm-block d-md-block d-lg-none d-xl-none"} style={{fontSize: "x-large"}}>
                                        <div>Reviews | {reviewList.length}</div>
                                    </div>
                                    <span>
                                        <Link to="/profile/editProfile">
                                            <button type="button"
                                                    className="btn btn-danger">
                                            Edit Profile
                                            </button>
                                        
                                        
                                        </Link>

                                        {
                                            
                                            user.uType === '2' &&
                                            <Link to="/business/details">
                                                <button className="btn btn-primary">
                                                    Add Restaurant
                                                </button>
                                            </Link>
                                            
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProfileComponent;
